import MuiDialogContent from '@mui/material/DialogContent'

export default function DialogContent(props: Record<string, any>): JSX.Element {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MuiDialogContent {...props} />
}
